export enum LocalStorageKeyEnum {
    CART_NUMBER = "cart_number",
    USER_NAME = "username",
    TOKEN = "access_token",
    TOKEN_TYPE = "token_type",
    IS_ANONYMOUS = "is_anonymous",
    ANONYMOUS_USER_ID = "anonymous_user_id",
    FIRST_NAME = "first_name",
    COUNTRY_CODE = "country_code",
    EXPIRE = "expire",
    STORE_LIST = "store_list",
    STORE_LIST_EXPIRE = "store_list-expire",
    PARTNER_TYPE = "partner_type",
    CATALOG_LIST = "catalog_list",
    CATALOG_LIST_EXPIRE = "catalog_list-expire",
    DEFAULT_CATALOG = "default_catalog",
    CURRENCY_CODE = "currency_code",
    PRIVACY_POLICY = "privacy_policy",
    CLIENT_ROOT_ID = "client_root_id",
    ORDER_STATUS = "order_status",
    ORDER_STATUS_TIME = "order_status_time",
    BULK_ORDER_ID = "bulk_order_Id"
}